module.exports = __webpack_public_path__ + "static/img/homeimg-525.c80fbc6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/homeimg-525.png
// module id = tUIS
// module chunks = 1